/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */
import { AppType } from "../types";

export const getAppType = (browserGlobalScope: Window & typeof globalThis): AppType => {
  let appType: AppType;
  if (browserGlobalScope.parent !== browserGlobalScope || browserGlobalScope.self !== browserGlobalScope.top || browserGlobalScope.frameElement) {
    appType = AppType.child;
  }
  else {
    appType = AppType.parent;
  }
  return appType;
}
